<div>
    <h2>{{'logs.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'logs.filters.user' | translate}}</label>
                <input type="text" formControlName="userName">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'logs.filters.rol' | translate}}</label>
                <app-filterable-list [itemsList]="roles" [selectedItem]="filtersForm.get('applicationRoleId')">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'logs.filters.tipoLog' | translate}}</label>
                <app-filterable-list [itemsList]="tiposLogs" [selectedItem]="filtersForm.get('tipoLogId')">
                </app-filterable-list>
            </div>
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 1)">
                          {{'logs.table.fechaIns' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
                        </th>
                        <th class="string">{{'logs.table.usuario' | translate}}</th>
                        <th class="string">{{'logs.table.rol' | translate}}</th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.TipoLogId', 4)">
                          {{'logs.table.tipoLog' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.TipoLogId')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.origen', 5)">
                          {{'logs.table.origen' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.origen')"></i></div>
                        </th>
                        <th class="action"></th>
                    </tr>
                </thead>
                <tbody *ngFor="let log of logs; let i = index; trackBy: trackByLogId">
                    <tr>
                        <td class="date">{{log.fechaIns | date: 'short' : undefined : defaultLanguage}}</td>
                        <td class="string">{{log.userName}}</td>
                        <td class="string">{{log.roleNames}}</td>
                        <td class="string">{{log.desTipoLog}}</td>
                        <td class="string-overflow" title="{{log.origen}}">{{log.origen}}</td>
                        <td class="actions">
                            <i class="fas fa-stream" (click)="showSection(i)"
                                title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownSection === i">
                        <td colspan="6" class="string-long">
                            <div class="detail">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block">
                                    <p class="string-overflow" [innerHtml]="log.descripcion" title="{{log.descripcion}}"></p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!logs || (logs && logs.length < 1)">
                    <tr>
                        <td colspan="6">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="logs && logs.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>
